<!-- Breadcrumbs -->
<nav class="breadcrumb" role="navigation" aria-label="Breadcrumbs">
  <!-- For each item in the breadcrumbs -->
  @for (breadcrumb of breadcrumbs; track breadcrumb; let i = $index) {
    <!-- Display the label if current page -->
    @if (i === breadcrumbs.length - 1) {
      <span class="breadcrumb-end">
        {{ breadcrumb.label }}</span
        >
      } @else {
        <!-- To display the home icon as breadcrumb item -->
        @if (breadcrumb.url === rootPage) {
          <a class="breadcrumb-hidden" [routerLink]="rootPage">
            <span class="zmdi zmdi-home"></span>
          </a>
        }
        <!-- Rest of the link / label items -->
        @if (breadcrumb.url && breadcrumb.url !== rootPage) {
          <a
            class="breadcrumb-hidden"
            [routerLink]="breadcrumb.url"
            #ok
            >
            {{ breadcrumb.label }}
            <span class="zmdi zmdi-chevron-right breadcrumb-hidden"></span>
          </a>
        } @else {
          <span>
            {{ breadcrumb.label }}
          </span>
          <span class="zmdi zmdi-chevron-right breadcrumb-hidden"></span>
        }
      }
      <!-- Else, associate a link with the label-->
    }
  </nav>
